import React, { useState, useRef, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { BASE_URL } from "./axios";
import { ToastContainer, toast } from 'react-toastify';


import { handleErrorToast, sortProjects } from "../../utils/ReusableFunctions";
import { AddwithWhiteCircle, DeleteDustbin, Tripledot, UpdatePencil, DropdownArrowOption, Attachment } from "../../utils/ReusableSVGs";
import { useNavigate } from "react-router-dom";

const AddSiteDepartments = ({ i, getSiteSubcompanies }) => {
    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState({
        title: "",
        sub_company: ""
    });
    const [errors, setErrors] = useState({});

    const handleClose = () => {
        setFormData({ title: "", sub_company: "" });
        setErrors({});
        setShow(false);
    };
    const handleShow = () => setShow(true);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors((prev) => {
            let updated = { ...prev };
            delete updated[name];
            return updated;
        });
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (!formData.title) {
            setErrors({ title: "Title is required" });
            return;
        }
        if (!formData.sub_company) {
            setErrors({ sub_company: "Sub-company is required" });
            return;
        }

        const loadingToastId = toast.loading("Saving department...");
        try {
            await axios.post(`${BASE_URL}/configuration/department/`, formData);
            toast.success("Department added successfully");
            handleClose();
            await getSiteSubcompanies();
        } catch (err) {
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };
    const [subCompanies, SetSubCompanies] = useState([])
    const getSubCompany = async () => {

        try {



            const res = await axios.get(
                // `${BASE_URL}/configuration/subcompanyfilterbysubcompanycount/${toggleCompany}/active/`
                `${BASE_URL}/configuration/subcompany/`
                // `${BASE_URL}/configuration/subcompany`
            );
            SetSubCompanies(res.data);
        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {

        }
    };

    useEffect(() => {
        if (show) {
            getSubCompany()
        }
    }, [show])
    return (
        <>
            <button onClick={handleShow} className="upload-svg">
                <AddwithWhiteCircle /> Department
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
                <Modal.Header closeButton>
                    <Modal.Title>Add Department</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleFormSubmit} className="register-form">
                        <div className="flex-column">
                            <label>Title</label>
                            <input
                                type="text"
                                name="title"
                                value={formData.title}
                                onChange={handleInputChange}
                                className={`form-input ${errors.title ? "error" : ""}`}
                            />
                            {errors.title && <span className="error-message">{errors.title}</span>}
                        </div>

                        <div className="flex-column">
                            <label>Sub Company</label>
                            <select
                                name="sub_company"
                                value={formData.sub_company}
                                onChange={handleInputChange}
                                className={`form-input ${errors.sub_company ? "error" : ""}`}
                            >
                                <option value="">Select Sub Company</option>
                                {console.log(subCompanies, 'subCompany')}
                                {subCompanies.map((sc) => (
                                    <option key={sc.id} value={sc.id}>
                                        {sc.company_name
                                        }
                                    </option>
                                ))}
                            </select>
                            {errors.sub_company && (
                                <span className="error-message">{errors.sub_company}</span>
                            )}
                        </div>

                        <div className="button-models">
                            <button type="submit" className="model-button model-button-submit">
                                Add
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
};

const UpdateSiteDepartmentupdate = ({ i, getSiteSubcompanies }) => {
    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState({
        title: "",
        sub_company: ""
    });
    const [errors, setErrors] = useState({});

    const handleClose = () => {
        setFormData({ title: "", sub_company: "" });
        setErrors({});
        setShow(false);
    };
    const handleShow = () => {
        setShow(true);
        setFormData(i);

    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors((prev) => {
            let updated = { ...prev };
            delete updated[name];
            return updated;
        });
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (!formData.title) {
            setErrors({ title: "Title is required" });
            return;
        }
        if (!formData.sub_company) {
            setErrors({ sub_company: "Sub-company is required" });
            return;
        }

        const loadingToastId = toast.loading("Saving department...");
        try {
            await axios.post(`${BASE_URL}/configuration/department/`, formData);
            toast.success("Department added successfully");
            handleClose();
            await getSiteSubcompanies();
        } catch (err) {
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };
    const [subCompanies, SetSubCompanies] = useState([])
    const getSubCompany = async () => {

        try {



            const res = await axios.get(
                // `${BASE_URL}/configuration/subcompanyfilterbysubcompanycount/${toggleCompany}/active/`
                `${BASE_URL}/configuration/subcompany/`
                // `${BASE_URL}/configuration/subcompany`
            );
            SetSubCompanies(res.data);
        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {

        }
    };

    useEffect(() => {
        if (show) {
            getSubCompany()
        }
    }, [show])
    return (
        <>
            <button onClick={handleShow} className="model-edit-button">
                <UpdatePencil />
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
                <Modal.Header closeButton>
                    <Modal.Title>Add Department</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleFormSubmit} className="register-form">
                        <div className="flex-column">
                            <label>Title</label>
                            <input
                                type="text"
                                name="title"
                                value={formData.title}
                                onChange={handleInputChange}
                                className={`form-input ${errors.title ? "error" : ""}`}
                            />
                            {errors.title && <span className="error-message">{errors.title}</span>}
                        </div>

                        <div className="flex-column">
                            <label>Sub Company</label>
                            <select
                                name="sub_company"
                                value={formData.sub_company}
                                onChange={handleInputChange}
                                className={`form-input ${errors.sub_company ? "error" : ""}`}
                            >
                                <option value="">Select Sub Company</option>
                                {subCompanies.map((sc) => (
                                    <option key={sc.id} value={sc.id}>
                                        {sc.title}
                                    </option>
                                ))}
                            </select>
                            {errors.sub_company && (
                                <span className="error-message">{errors.sub_company}</span>
                            )}
                        </div>

                        <div className="button-models">
                            <button type="submit" className="model-button model-button-submit">
                                Add
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
};


const DeleteSiteDepartment = ({ i, getSiteSubcompanies }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();

        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
        try {
            let res = await axios.delete(`${BASE_URL}/configuration/department/${i.id}/`);

            if (res.status === 200) {
                setShow(false);
                await getSiteSubcompanies();
            } else {
                alert(res);
            }
        } catch (err) {
            //toast Logic
            handleErrorToast(err)
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Department {i.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete Department {i.title}
                        <div className="button-models">
                            <button className="model-button   font-weight500    model-button-cancel" onClick={handleClose}>
                                Cancel
                            </button>

                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};


export {
    AddSiteDepartments,
    UpdateSiteDepartmentupdate,
    DeleteSiteDepartment,
}